<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-08-18 10:36:15
 * @Description: 云渲染工具栏
 * @LastEditors: fengxiaojing
-->
<template>
  <div
    v-if="currentBasicTab.length > 0"
    class="cursor-pointer w-full flex items-center justify-center absolute bottom-0 mr-12px h-50px"
  >
    <div
      class="z-12px basic_tab  flex items-center justify-center"
      :style="{ width: `${currentBasicTab.length * 44 + 10}px` }"
    >
      <div class="flex items-center justify-center h-40px basicTabId relative">
        <el-tag
          v-for="(tab, tabIndex) in currentBasicTab"
          :key="tab.id"
          @click="tagsClick(tab, tabIndex, 'tab')"
          disable-transitions
          class="p-5px border-none flex items-center bg-[#fff0] "
        >
          <template v-if="tab.children && tab.children.length > 0">
            <el-popover
              placement="top"
              popper-class="tag_popover"
              :width="`${tab.children.length * 32 + 20}`"
              trigger="hover"
            >
              <div class="tag_popover__item">
                <el-tag
                  v-for="tabChild in tab.children"
                  :key="tabChild.id"
                  disable-transitions
                  @click="tagsClick(tabChild, tabIndex, 'tabChild')"
                  class="m-r-5"
                  :class="currentActiveTag === tabChild.detail.code ? 'actived' : ''"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="tabChild.detail.name"
                    placement="top"
                  >
                    <span
                      class="iconfont text-20px text-[#fff]"
                      :class="`icon-${tabChild.detail.icon} `"
                    ></span>
                  </el-tooltip>
                </el-tag>
              </div>
              <span
                slot="reference"
                class="iconfont text-20px text-[#fff] w-23px h-23px text-center leading-23px"
                :class="`icon-${tab.detail.icon}`"
              ></span>
            </el-popover>
          </template>
          <template v-else>
            <el-tooltip effect="dark" :content="tab.detail.name" placement="top">
              <span
                class="iconfont text-20px w-23px h-23px text-center leading-23px"
                :class="`icon-${tab.detail.icon} text-[#fff]`"
              ></span>
            </el-tooltip>
          </template>
        </el-tag>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaiscTab',
  props: {
    tabList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    activeTag: {
      type: String,
      defalut: '',
    },
    selectTagList: {
      type: Array,
      defalut: () => {
        return []
      },
    },
  },
  data() {
    return {
      currentBasicTab: [],
      changeActiveTag: false, // 是否切换tag
      currentActiveTag: '',
    }
  },
  watch: {
    tabList() {
      // 筛选当前板块的功能
      this.currentBasicTab = this.filterTabBar(this.tabList)
      if (this.currentActiveTag) {
        this.changeActiveTag = true
        const index = _.findIndex(this.currentBasicTab, (el) => {
          return el.detail.code === this.currentActiveTag
        })
        this.addClass(index)
      }
    },
    activeTag() {
      this.currentActiveTag = this.activeTag
      this.changeActiveTag = true
      const index = _.findIndex(this.currentBasicTab, (el) => {
        return el.detail.code === this.currentActiveTag
      })
      this.addClass(index)
    },
  },
  created() {
    this.currentActiveTag = this.activeTag || ''
  },
  methods: {
    filterTabBar(tabList) {
      // 筛选出isSelected为true的数据
      return _.filter(tabList, (element) => {
        if (element.isSelected && !_.isEmpty(element.children)) {
          element.children = this.filterTabBar(element.children)
        }
        return element.isSelected
      })
    },
    tagsClick(tab, index, type) {
      if (type === 'tab' && !_.isEmpty(tab.children)) {
        return
      }
      this.$emit('tabsClick', {
        id: tab.id,
        name: tab.detail.name,
        code: tab.detail.code,
        origin: 'basic',
        locationType: tab.detail.functionLocationType,
      })
      this.currentActiveTag = tab.detail.code
    },
    /**
     * @description: 气泡动画
     * @param {*} index：目标元素索引
     * @return {*}
     */
    addClass(index) {
      // 不存在激活的
      if (index === -1) {
        document.styleSheets[0].addRule('.basicTabId::after', 'content: none;')
      } else {
        this.changeActiveTag &&
          document.styleSheets[0].addRule(
            '.basicTabId::after',
            ` left: ${index * 33.5 + 2}px; transition: left 1s;content: ''`
          )
      }
      this.changeActiveTag = false
    },
  },
}
</script>
<style lang="scss">
.el-popover.tag_popover {
  padding: 0;
  min-width: 20px;
  background: linear-gradient(#113444cc, #097fa4cc);
  background-color: #d0efff;
  border: none;
  border-radius: 32px;

  &[x-placement^='top'] .popper__arrow {
    border-top-color: #097fa4cc;

    &::after {
      border-top-color: #097fa4cc;
    }
  }
}
</style>
<style lang="scss" scoped>
.basic_tab {
  background: linear-gradient(#113444cc, #097fa4cc);
  border-radius: 32px;
}

.basicTabId {
  &::after {
    position: absolute;
    z-index: 3;
    width: 30px;
    height: 30px;
    background: linear-gradient(#3cbce4, #1d99c080, #1134444d);
    background-color: #d0efff;
    border-radius: 50%;
  }
}

.el-tag {
  display: flex !important;
  align-items: center;
  padding: 5px;
  background-color: #fff0;
  border: none;

  span {
    z-index: 10;
    width: 23.5px;
    height: 23px;
    text-align: center;
    line-height: 23px;
  }

  &.selected {
    animation: rock 1s;
    position: relative;

    &::after {
      position: absolute;
      left: 1px;
      z-index: 0;
      width: 30px;
      height: 30px;
      background: #037ea480;
      border-color: #0d66af;
      border-radius: 50%;
      content: '';
    }
  }
}

.tag_popover {
  &__item {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 40px;
    border-radius: 12px;

    .el-tag {
      display: flex !important;
      align-items: center;
      padding: 5px;
      margin: 5px 0;
      background-color: #fff0;
      border: none;

      & span {
        width: 23.5px;
        height: 23px;
        text-align: center;
        line-height: 23px;
      }

      &.actived {
        background: linear-gradient(#1167b1, #6db5da);
        background-color: #d0efff;
        border-radius: 50%;
      }
    }
  }
}
@keyframes rock {
  0% {
    transform: translateX(0);
    transform: translateX(0);
  }

  25% {
    transform: translateX(-2px);
    transform: translateX(-2px);
  }

  50% {
    transform: translateX(0);
    transform: translateX(0);
  }

  75% {
    transform: translateX(2px);
    transform: translateX(2px);
  }

  100% {
    transform: translateX(0);
    transform: translateX(0);
  }
}
</style>
